// extracted by mini-css-extract-plugin
export default {"addNewPlayerModalWrapper":"addPlayer_addNewPlayerModalWrapper__0fO-L","playersWrapper":"addPlayer_playersWrapper__MLYFu"};